import React from 'react'

const Home = (props) => {

return (
     <section>
     <div className = "greeting">
          <h2 className='welcome'data-text="Welcome!">Welcome!</h2>

         <p>I'm Andrea! I'm a Full Stack Web Developer excited to show you my projects! Have a look around!!</p>
    </div>
    
    </section>
)

}

export default Home;